import React, { FC, useEffect, useState } from "react";
import {
  Container,
  TitleBig,
  FormWrapper,
  CreatedOverlay,
  EstimateContainer,
  EstimateTitle,
  EstimateSum,
  PerHour,
  CreateContainer,
} from './styles'
import {
  BackArrow,
  Input,
  RadioButtonGroup,
  Select,
  Button,
  RevealButton,
  Counter,
  Toggle,
  DragAndDrop,
  TopProgress,
  LoaderSpinner
} from "../../../../components";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../../../../context/navigationContext";
import * as yup from 'yup';
import { useFormik } from 'formik';
import { imageService, clientService } from "../../../../api";
import { useUi } from "../../../../context/ui.context";
import { fileRequestHandler } from "../../../../utils/request-file-handler";
import { useTheme } from "styled-components";
import { formatCurrencyString,formatCurrency } from "../../../../utils/display-price";
import { useAuth } from "../../../../context/user.context";
import { ErrorText } from "../../../HomePage/styles";



const CreateAndEditImage:FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  usePageTitle(t("PAGE_TITLE_IMAGE_CREATE"))
  const {viewAlert, updateAlertProgress} = useUi()
  const theme:any = useTheme()
  const {user} = useAuth()
  // const [protectedValue, setProtected] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [visibilities, setVisibilities] = useState<any[]>([])
  const [diskFormats, setDiskFormats] = useState<any[]>([])
  const [diskFormatsValidation, setDiskFormatsValidation] = useState<any[]>([])
  const [architecture, setArchitecture] = useState<string>('')
  const [distro, setDistro] = useState<any[]>([])
  const [region, setRegion] = useState<string>('')
  const [file, setFile] = useState<any>()
  const [priceLoading, setPriceLoading] = useState<boolean>(false)
  const [price, setPrice] = useState<any>()
  const [priceMonth, setPriceMonth] = useState<any>()
  const [oneSubmitted, setOneSubmitted] = useState<boolean>(false)
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [createInClientProject, setCreateInClientProject] = useState<boolean>(false)
  const [clients, setClients] = useState<any[]>([])
  const [clientsLoading, setClientsLoading] = useState<boolean>(false)
  const [clientSearchString, setClientSearchString] = useState<string>('')

  const [initialValues, setInitialValues ] = useState<any>({
    disk_format:'qcow2',
    source:'url',
    name:'',
    url:'',
    min_disk:'1',
    min_ram:'1',
  })
  const getCreateOptions = () => {
    imageService.getCreateOptions()
    .then((res) => {
      setArchitecture(res.data.architectures?.[0]?.[0])
      setDistro(res.data.os_distros.map((os:any) => {
        return {
          value:os,
          label:os,
        }
      }))
      setDiskFormats(res.data.disk_formats.map((format:string) => {
        return {
          value:format,
          label:format,
        }
      }))
      setDiskFormatsValidation(res.data.disk_formats.map((format:string) => format))
      setRegion(res.data.regions?.[0]?.id)
      setVisibilities(res.data.visibilities.map((visibility:string) => {
        return{
          value:visibility,
          label:visibility,
        }
      }))
      setPageLoading(false)
    })
    .catch((err) => {
      
    })
    .finally(() => {

    })
  }
  useEffect(() => {
    getCreateOptions()
  },[])

  useEffect(() => {
    if (createInClientProject) {
      setClientsLoading(true)
      clientService.getAll({
        page: 1,
        page_size: 100,
        search: clientSearchString,
      }).then((res: any) => {
        setClients(res.data.objects.map((client: any) => ({
          ...client,
          value: client.id,
          label: client.name || client.email,
        })));
      }).catch((err: any) => {
        console.error('Failed to load clients:', err);
      }).finally(() => {
        setClientsLoading(false)
      })
    }
  }, [createInClientProject, clientSearchString])

  const handleDestinationChange = (isClient: boolean) => {
    setCreateInClientProject(isClient)
    if (!isClient) {
      setSelectedClient(null)
    }
  }
  const onSubmit = (values:any) => {
    setLoading(true)
    const data:any = {
      ...values,
      region:region,
      protected:false,
      architecture:architecture,
      visibility:visibilities?.[0]?.value,
      hypervisor_type: ''
    }

    // Add create_as_admin flag if creating in admin project
    if (!createInClientProject) {
      data.create_as_admin = true;
    }

    // Add client if creating in client project
    if (createInClientProject && selectedClient) {
      data.client = selectedClient;
    }

    if(file && values.source === 'file'){
      data.file = file
      delete data.url
    }
    const handledData = fileRequestHandler(values.source, data)
    imageService.createImage(handledData.body, handledData.headers,
      updateAlertProgress, (values.source === 'file' ? viewAlert({
        severity:'image',
        // timeout:0,
        message: '',
        canClose:false,
      }): null)) 
    .then((res) => {
      viewAlert({
        severity:'info',
        message: `${t("IMAGE_SUCCESSFULLY_CREATED")}`
      })
      setLoadingComplete(true)
      setTimeout(() => {
        setLoading(false)
        setLoadingComplete(false)
        if(res?.data?.detail){
          viewAlert({
            severity:'info',
            message: res.data.detail
          })
        }
        navigate('/openstack/images')
      },1000)

    })
    .catch((e) => {
      if(e?.response?.data?.detail){
        viewAlert({
          severity:'error',
          message: e.response.data?.detail
        })
        setLoading(false)
      } else {
        setErrors(e?.response?.data)
        setLoading(false)
      }
    })
  }
  const regName = /^[a-zA-Z0-9\\!\"#$%&'()*+,\-./:;<=>?@\[\\\]\^_`{\|}~ ]+$/
  const {
    values,
    errors,
    touched,
    setErrors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string()
      .required(`${t('REQUIRED_FIELD')}`)
      .matches(regName,`${t("ONLY_ENGLISH_LETTERS")}`)
      .max(60, `${t("STRING_VALIDATE_MAX")} 60 ${t("CHARACTERS")}`),
      visibility:yup.string(),
      os_distro:yup.string(),
      os_version:yup.string(),
      min_disk:yup.string(),
      min_ram:yup.string(),
      disk_format:yup.string(),
      source:yup.string(),
      url: yup.string().when("source", {
        is: (source:any) => source === 'url',
        then: yup.string().required(`${t('REQUIRED_FIELD')}`)
      }),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  const getCurrentPrice = () => {
    // Only calculate price for client if createInClientProject is true
    if (createInClientProject && !selectedClient) {
      setPrice(null)
      setPriceMonth(null)
      return
    }

    let queries:any = {
      region: region,
      visibility:visibilities?.[0]?.value,
      disk_format:values['disk_format'],
    }
    if(values['source'] === 'file' && file){
      queries.size = file.size
    }

    if (createInClientProject && selectedClient) {
      queries.client_id = selectedClient
    }

    if(!pageLoading){
      setPriceLoading(true)
      imageService.getPrice(queries)
      .then((res) => {
        setPrice(formatCurrencyString(res.data.estimated_cost_display.split('-')[0]).hour)
        setPriceMonth(formatCurrencyString(res.data.estimated_cost_display.split('-')[1]).month)
        setPriceLoading(false)
      })
      .catch((err) => {
        setPriceLoading(false)
        setPrice(null)
        setPriceMonth(null)
      })
    }
  }
  
  useEffect(() => {
    getCurrentPrice()
  },[
    values?.visibility,
    values?.disk_format,
    file,
    selectedClient,
    createInClientProject
  ])
    const buttonsDisk = [
      {
        value:'url',
        id:'url',
        title:t('URL')
      },
      {
        value:'file',
        id:'file',
        title:t('DISK')
      },
    ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <CreateContainer>
      <Container>
        <CreatedOverlay active={loading && values['source'] === 'file'}/>
        <BackArrow
          fallbackPath="/openstack/images"
        />
        <TitleBig>{t("CREATE_NEW_IMAGE")}</TitleBig>
        <FormWrapper>
          <div style={{width: '500px', marginBottom: '20px'}}>
            <RadioButtonGroup
              toolTip={false}
              title={t("DESTINATION")}
              buttons={[
                {
                  value: 'admin',
                  id: '1',
                  title: t("CREATE_IMAGE_IN_ADMIN_PROJECT")
                },
                {
                  value: 'client',
                  id: '2',
                  title: t("CREATE_IMAGE_IN_CLIENT_PROJECT")
                }
              ]}
              selectedButton={createInClientProject ? 'client' : 'admin'}
              onChange={(value: string) => handleDestinationChange(value === 'client')}
            />
          </div>
          {createInClientProject && (
            <Select
              required
              toolTip={false}
              data={clients}
              selectedValue={selectedClient}
              onChange={(id: any) => setSelectedClient(id)}
              title={t("CLIENT")}
              placeholder={t("SELECT_CLIENT")}
              fieldName='client'
              hasSearch={true}
              onSearchChange={setClientSearchString}
              customStyles={{width:'360px', marginBottom:'20px'}}
            />
          )}
          <Input
            required
            fieldName='name'
            title={t("NAME_IMAGE")}
            placeholder=''
            {...formikProps}
          />
          {/* <Select
            toolTip={false}
            data={visibilities}
            selectedValue={values['visibility']}
            onChange={(e) => handleChange('visibility')(e)}
            title={t("VISIBILITY")}
            fieldName='visibility'
            {...formikProps}
          /> */}
          <Select
            toolTip={false}
            test_id="image-type"
            data={diskFormats}
            selectedValue={values['disk_format']}
            onChange={(e) => handleChange('disk_format')(e)}
            title={t("DISK_FORMAT")}
          />
          <div style={{width: '250px'}}>
            <RadioButtonGroup
              toolTip={false}
              title={t("SOURCE")}
              buttons={buttonsDisk}
              selectedButton={values['source']}
              onChange={(e) => handleChange('source')(e)}
            />
          </div>
        </FormWrapper>

        <FormWrapper style={{marginBottom:'20px', marginTop:'20px'}}>
          {values['source'] === 'file' ?
          <div>
            <DragAndDrop
              required
              uploadedFile={file}
              onChange={setFile}
              isImage
              formats={
                diskFormatsValidation.join(', ')
                // 'iso, mdf, img, dmg, bin, nrg, qcow2'
              }
              fileValidation={
                // ['iso', 'mdf', 'img', 'dmg', 'bin', 'nrg', 'qcow2']
                diskFormatsValidation
              }
              requiredListener={values['source'] === 'file' && oneSubmitted && !file}
            />
          </div>
          :
            <Input
              required
              fieldName='url'
              title={t("URL")}
              placeholder=''
              customStyles={{width:'360px'}}
              {...formikProps}
            />
          }
        </FormWrapper>
        <div style={{width:'400px', marginTop:'0px', display:'flex', alignItems:'flex-start'}}>
          <RevealButton
            // customStyles={{width:'188px'}}
            title={t("ADDITIONAL_SETTINGS")}
        >
            {/* <FormWrapper> */}
              <Select
                toolTip={false}
                data={distro}
                selectedValue={values['os_distro']}
                onChange={(e) => handleChange('os_distro')(e)}
                title={t("OS")}
                test_id="image-os"
                customStyles={{marginBottom:'14px'}}
              />
              <Input
                fieldName='os_version'
                title={t("OS_VERSION")}
                placeholder=''
                customStyles={{marginBottom:'14px', width:'360px'}}
                {...formikProps}
              />
              <Counter
                customStyles={{marginBottom:"20px"}}
                title={t("MINIMUM_DISK_SIZE")}
                value={values['min_disk']}
                hideItems={'GB'}
                fieldName={'min_disk'}
                minCount={1}
                onChange={(v:any) => {
                  handleChange('min_disk')(v.toString())}}
              />
              <Counter
                customStyles={{marginBottom:"20px"}}
                title={t("MINIMUM_REQUIRED_RAM")}
                value={values['min_ram']}
                minCount={1}
                hideItems={'GB'}
                fieldName={'min_ram'}
                onChange={(v:any) => {
                  handleChange('min_ram')(v.toString())}}
              />
              {/* <Toggle
                title={t("PROTECTED")} 
                value={protectedValue}
                onChange={() => setProtected(!protectedValue)}
              /> */}

            {/* </FormWrapper> */}
          </RevealButton>
        </div>
        <div style={{display:'flex', marginTop:'40px'}}>
          <Button
            variant="primary"
            size="display"
            customStyles={{marginRight:"10px"}}
            onClick={() => {
              setOneSubmitted(true)
              handleSubmit()
            }}
            loading={loading}
            disabled={values['source'] === 'file' && !file}
            loadingComplete={loadingComplete}
            title={t("CREATE")}
          />
          <Button
            variant="stroke"
            size="display"
            // customStyles={{width: '81px'}}
            onClick={() => navigate("/openstack/images")}
            title={t("CANCEL")}
          />
        </div>
      </Container>
      <EstimateContainer>
        <EstimateTitle>
          {t("ESTIMATED_COST")}
        </EstimateTitle>
        {priceLoading ? 
          <LoaderSpinner customStyles={{color:theme.base.black}}/>
        :
          price ? 
            <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
              <div style={{display:'flex', alignItems:'flex-end'}}>
                <EstimateSum>
                  {`${formatCurrency(price, user.user.clients?.[0]?.currency || 'UAH')}`}
                </EstimateSum>
                <PerHour>{t("HOURS")}</PerHour>
              </div>
              <div style={{display:'flex', alignItems:'flex-end'}}>
                <EstimateSum>
                  {`${formatCurrency(priceMonth, user.user.clients?.[0]?.currency || 'UAH')}`}
                </EstimateSum>
                <PerHour>{t("MONTH")}</PerHour>
              </div>
            </div>
          :
          <PerHour>
            {t("SELECT_OPTIONS_TO_DISPLAY_PRICE")}
          </PerHour>
        }
      </EstimateContainer>
    </CreateContainer>
  )
}

export default CreateAndEditImage



